export default function (superClass) {
  return class extends superClass {
    constructor(...arg) {
      // @ts-ignore
      super(...arg)
    }

    install() {
      super.install()
    }

    destroy() {
      super.destroy()
    }

    display() {
      let x = "", y = "", snappedX = this.snappedX, snappedY = this.snappedY
      if (snappedX) {
        x = `
        <path 
          d="M${snappedX},-100000 L${snappedX},100000"
          stroke="rgb(255, 195, 66)"
          stroke-opacity=".5"
          stroke-width="2"
          pointer-events="none"
        >
        </path>
        `
      }

      if (snappedY) {
        y = `
          <path 
            d="M-100000,${snappedY} L100000,${snappedY}"
            stroke="rgb(255, 195, 66)"
            stroke-opacity=".5"
            stroke-width="2"
            pointer-events="none"
          ></path>
        `
      }
      return super.display() + `<g>${x}${y}</g>`
    }
  }
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/Layers/HelperLayerMixin.js